var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.854 1.146a.5.5 0 1 0-.708.708L5.293 6l-4.147 4.146a.5.5 0 0 0 .708.708L6 6.707l4.146 4.147a.5.5 0 0 0 .708-.708L6.707 6l4.147-4.146a.5.5 0 0 0-.708-.708L6 5.293z",
    clipRule: "evenodd"
  })));
});
const SvgClosesmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClosesmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjg1MzU1IDEuMTQ2NDVDMS42NTgyOSAwLjk1MTE4NCAxLjM0MTcxIDAuOTUxMTg0IDEuMTQ2NDUgMS4xNDY0NUMwLjk1MTE4NCAxLjM0MTcxIDAuOTUxMTg0IDEuNjU4MjkgMS4xNDY0NSAxLjg1MzU1TDUuMjkyODkgNkwxLjE0NjQ1IDEwLjE0NjRDMC45NTExODQgMTAuMzQxNyAwLjk1MTE4NCAxMC42NTgzIDEuMTQ2NDUgMTAuODUzNkMxLjM0MTcxIDExLjA0ODggMS42NTgyOSAxMS4wNDg4IDEuODUzNTUgMTAuODUzNkw2IDYuNzA3MTFMMTAuMTQ2NCAxMC44NTM2QzEwLjM0MTcgMTEuMDQ4OCAxMC42NTgzIDExLjA0ODggMTAuODUzNiAxMC44NTM2QzExLjA0ODggMTAuNjU4MyAxMS4wNDg4IDEwLjM0MTcgMTAuODUzNiAxMC4xNDY0TDYuNzA3MTEgNkwxMC44NTM2IDEuODUzNTVDMTEuMDQ4OCAxLjY1ODI5IDExLjA0ODggMS4zNDE3MSAxMC44NTM2IDEuMTQ2NDVDMTAuNjU4MyAwLjk1MTE4NCAxMC4zNDE3IDAuOTUxMTg0IDEwLjE0NjQgMS4xNDY0NUw2IDUuMjkyODlMMS44NTM1NSAxLjE0NjQ1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";